import React, { useEffect, useState } from "react";
import axios from "axios";

const DataTable = () => {
    const [data, setData] = useState([]);

    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_API_BASE_URL}/data/`)
            .then((response) => setData(response.data))
            .catch((error) => console.error("Error fetching data:", error));
    }, []);

    return (
        <div className="bg-white shadow-md rounded-lg p-6 my-6">
            <h2 className="text-2xl font-semibold mb-4 text-gray-800">
                Datos de la Base
            </h2>
            <div className="overflow-x-auto">
                <table className="table-auto w-full border-collapse border border-gray-300">
                    <thead className="bg-gray-200">
                        <tr>
                            <th className="border border-gray-300 px-4 py-2">
                                ID
                            </th>
                            <th className="border border-gray-300 px-4 py-2">
                                Cliente
                            </th>
                            <th className="border border-gray-300 px-4 py-2">
                                Producto
                            </th>
                            <th className="border border-gray-300 px-4 py-2">
                                Cantidad
                            </th>
                            <th className="border border-gray-300 px-4 py-2">
                                Fecha
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((purchase, index) => (
                            <tr
                                key={index}
                                className={`${
                                    index % 2 === 0 ? "bg-gray-100" : "bg-white"
                                }`}
                            >
                                <td className="border border-gray-300 px-4 py-2">
                                    {purchase.id}
                                </td>
                                <td className="border border-gray-300 px-4 py-2">
                                    {purchase.client}
                                </td>
                                <td className="border border-gray-300 px-4 py-2">
                                    {purchase.product}
                                </td>
                                <td className="border border-gray-300 px-4 py-2">
                                    {purchase.qty}
                                </td>
                                <td className="border border-gray-300 px-4 py-2">
                                    {new Date(purchase.date).toLocaleString()}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default DataTable;
